/* eslint-disable react/self-closing-comp */
// To add more SVG Icon can add here the "content" inside of the <svg>"content"</svg>
// and replace the fill attr with `var(--fill-color)`
export const Icons = {
  dashboard: (
    <svg
      width="29px"
      height="29px"
      viewBox="0 0 29 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>dashboard</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-14.000000, -70.000000)"
          fill="var(--fill-color)"
        >
          <g transform="translate(0.500000, 0.000000)">
            <g>
              <g transform="translate(0.000000, 56.000000)">
                <path d="M28.03,33 C27.754,33 27.525,32.777 27.525,32.5 C27.525,32.224 27.744,32 28.019,32 L28.03,32 C28.306,32 28.53,32.224 28.53,32.5 C28.53,32.777 28.306,33 28.03,33 L28.03,33 Z M20.648,17.192 L21.569,18.754 C21.662,18.912 21.829,19 22,19 C22.087,19 22.174,18.978 22.254,18.931 C22.492,18.791 22.571,18.484 22.431,18.246 L21.503,16.673 C23.294,15.685 25.333,15.105 27.5,15.025 L27.5,17.5 C27.5,17.776 27.724,18 28,18 C28.276,18 28.5,17.776 28.5,17.5 L28.5,15.025 C30.514,15.1 32.415,15.612 34.112,16.478 L33.069,18.246 C32.929,18.484 33.008,18.791 33.246,18.931 C33.326,18.978 33.413,19 33.5,19 C33.671,19 33.838,18.912 33.931,18.754 L34.983,16.969 C36.744,18.039 38.241,19.494 39.354,21.226 L37.231,22.578 C36.998,22.727 36.93,23.036 37.078,23.269 C37.174,23.419 37.335,23.5 37.5,23.5 C37.593,23.5 37.685,23.475 37.769,23.422 L39.873,22.081 C40.835,23.853 41.396,25.866 41.475,28 L39,28 C38.724,28 38.5,28.224 38.5,28.5 C38.5,28.777 38.724,29 39,29 L41.483,29 C41.445,30.008 41.3,31.014 41.034,32 L32.473,32 C32.285,30.311 31.158,28.902 29.628,28.306 L32.46,21.697 C32.568,21.444 32.451,21.15 32.197,21.041 C31.943,20.931 31.649,21.048 31.54,21.303 L28.644,28.061 C28.432,28.03 28.22,28 28,28 C25.687,28 23.777,29.753 23.527,32 L14.966,32 C14.7,31.014 14.555,30.008 14.517,29 L16.5,29 C16.776,29 17,28.777 17,28.5 C17,28.224 16.776,28 16.5,28 L14.525,28 C14.601,25.953 15.127,24.022 16.019,22.305 L17.757,23.308 C17.836,23.354 17.922,23.375 18.007,23.375 C18.179,23.375 18.348,23.286 18.439,23.125 C18.578,22.886 18.496,22.58 18.257,22.442 L16.517,21.437 C17.567,19.736 18.976,18.284 20.648,17.192 L20.648,17.192 Z M28,14 C20.005,14 13.5,20.505 13.5,28.5 C13.5,29.894 13.705,31.288 14.108,32.643 C15.925,38.741 21.637,43 28,43 C34.363,43 40.075,38.741 41.892,32.643 C42.295,31.288 42.5,29.894 42.5,28.5 C42.5,20.505 35.995,14 28,14 L28,14 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  update: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="var(--fill-color)"
    >
      <g>
        <rect fill="none" height="24" width="24" x="0" />
      </g>
      <g>
        <g>
          <g>
            <path d="M21,10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-0.1c-2.73,2.71-2.73,7.08,0,9.79s7.15,2.71,9.88,0 C18.32,15.65,19,14.08,19,12.1h2c0,1.98-0.88,4.55-2.64,6.29c-3.51,3.48-9.21,3.48-12.72,0c-3.5-3.47-3.53-9.11-0.02-12.58 s9.14-3.47,12.65,0L21,3V10.12z M12.5,8v4.25l3.5,2.08l-0.72,1.21L11,13V8H12.5z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  delete: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="var(--fill-color)"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
  ),
  settings: (
    <svg
      width="29px"
      height="30px"
      viewBox="0 0 29 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>settings</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-14.000000, -405.000000)"
          fill="var(--fill-color)"
        >
          <g transform="translate(0.500000, 0.000000)">
            <g>
              <g transform="translate(13.500000, 405.000000)">
                <path
                  d="M12.9992052,19.5 C12.9992052,20.88 11.8772052,22 10.4992052,22 C9.12120517,22 7.99920517,20.88 7.99920517,19.5 C7.99920517,18.12 9.12120517,17 10.4992052,17 C11.8772052,17 12.9992052,18.12 12.9992052,19.5 L12.9992052,19.5 Z M20.8572052,15.96 L18.7972052,12.5 C18.5452052,12.09 18.0522052,11.9 17.5582052,12.08 L15.2582052,12.98 C14.8302052,12.68 14.3852052,12.43 13.9062052,12.21 L13.5602052,9.82 C13.4712052,9.36 13.0392052,9 12.5552052,9 L8.44320517,9 C7.95520517,9 7.52320517,9.36 7.43420517,9.86 L7.09220517,12.23 C6.60820517,12.45 6.15620517,12.7 5.74120517,13 L3.43020517,12.09 C2.97920517,11.93 2.45420517,12.1 2.19720517,12.52 L0.145205173,15.97 C-0.112794827,16.39 -0.0167948275,16.94 0.385205173,17.27 L2.33020517,18.76 C2.30220517,19.02 2.28820517,19.26 2.28820517,19.5 C2.28820517,19.74 2.30220517,19.99 2.33120517,20.26 L0.370205173,21.76 C-0.0167948275,22.08 -0.112794827,22.63 0.141205173,23.04 L2.20120517,26.51 C2.45120517,26.91 2.94620517,27.11 3.44020517,26.93 L5.74020517,26.03 C6.16820517,26.33 6.61420517,26.58 7.09220517,26.8 L7.43720517,29.18 C7.52720517,29.65 7.95920517,30 8.44320517,30 L12.5552052,30 C13.0422052,30 13.4752052,29.64 13.5642052,29.15 L13.9062052,26.78 C14.3902052,26.56 14.8422052,26.3 15.2572052,26.01 L17.5692052,26.92 C17.6842052,26.96 17.8042052,26.98 17.9252052,26.98 C18.2842052,26.98 18.6102052,26.8 18.8012052,26.49 L20.8532052,23.04 C21.1112052,22.62 21.0152052,22.06 20.6132052,21.73 L18.6682052,20.25 C18.6962052,19.99 18.7102052,19.74 18.7102052,19.5 C18.7102052,19.27 18.6962052,19.02 18.6672052,18.74 L20.6272052,17.25 C21.0152052,16.93 21.1122052,16.37 20.8572052,15.96 L20.8572052,15.96 Z"
                  id="Fill-936"
                ></path>
                <path
                  d="M23.9992052,6 C23.9992052,6.55 23.5502052,7 22.9992052,7 C22.4482052,7 21.9992052,6.55 21.9992052,6 C21.9992052,5.45 22.4482052,5 22.9992052,5 C23.5502052,5 23.9992052,5.45 23.9992052,6 L23.9992052,6 Z M28.6982052,7.06 L27.7182052,6.32 C27.7272052,6.21 27.7332052,6.11 27.7332052,6 C27.7332052,5.89 27.7302052,5.79 27.7222052,5.69 L28.7122052,4.93 C28.9972052,4.68 29.0712052,4.28 28.8832052,3.94 L27.7602052,2.05 C27.5822052,1.73 27.2712052,1.55 26.7912052,1.71 L25.6432052,2.16 C25.4522052,2.03 25.2622052,1.93 25.0682052,1.84 L24.8982052,0.69 C24.8642052,0.3 24.5262052,0 24.1292052,0 L21.8722052,0 C21.4942052,0 21.1612052,0.28 21.0952052,0.66 L20.9202052,1.84 C20.7162052,1.94 20.5252052,2.05 20.3502052,2.16 L19.1832052,1.7 C19.1292052,1.68 18.9752052,1.66 18.9182052,1.66 C18.6472052,1.66 18.3962052,1.79 18.2362052,2.04 L17.1012052,3.95 C16.9122052,4.29 16.9942052,4.71 17.3022052,4.95 L18.2772052,5.69 C18.2712052,5.79 18.2682052,5.9 18.2682052,6 C18.2682052,6.11 18.2712052,6.21 18.2772052,6.31 L17.2782052,7.08 C16.9912052,7.33 16.9182052,7.73 17.1072052,8.06 L18.2292052,9.95 C18.3652052,10.2 18.6262052,10.35 18.9122052,10.35 C18.9992052,10.35 19.0862052,10.33 19.1992052,10.3 L20.3472052,9.85 C20.5372052,9.97 20.7282052,10.08 20.9212052,10.17 L21.0972052,11.36 C21.1622052,11.73 21.4882052,12 21.8722052,12 L24.1292052,12 C24.5072052,12 24.8402052,11.73 24.9062052,11.35 L25.0802052,10.16 C25.2862052,10.06 25.4742052,9.96 25.6452052,9.85 L26.8182052,10.3 C26.8722052,10.32 27.0262052,10.35 27.0822052,10.35 C27.3542052,10.35 27.6042052,10.21 27.7652052,9.97 L28.9012052,8.05 C29.0822052,7.73 29.0092052,7.32 28.6982052,7.06 L28.6982052,7.06 Z"
                  id="Fill-937"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  invitations: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="26"
      viewBox="0 0 30 26"
    >
      <path
        fill="var(--fill-color)"
        d="M16.1568003 12.3208003L13.2192003 12.3208003C11.0772002 12.3208003 9.05760019 13.2388003 7.58880016 14.8912004 6.18120013 16.4212004 5.38560011 18.5020004 5.32440011 20.7052005L5.32440011 24.8668006C5.32440011 25.1728006 5.56920012 25.4788006 5.93640012 25.4788006L23.5008005 25.4788006C23.8680005 25.4788006 24.1128005 25.1728006 24.1128005 24.8668006L24.1128005 20.8888005C23.9904005 16.1152004 20.4408004 12.3208003 16.1568003 12.3208003zM6.12000013 13.6672003C8.13960017 13.6672003 9.79200021 11.1580003 9.79200021 9.07720023 9.79200021 7.05760019 8.13960017 5.40520016 6.12000013 5.40520016 4.10040009 5.40520016 2.44800005 7.05760019 2.44800005 9.07720023 2.44800005 11.2192003 4.03920008 13.6672003 6.12000013 13.6672003zM10 4.88292683C10 7.6195122 12.3076923 11 15 11 17.6923077 11 20 7.6195122 20 4.88292683 20 2.2 17.7472527 0 15 0 12.2527473 0 10 2.2 10 4.88292683zM27.3440002 9.13840023C27.3440002 7.11880019 25.6916001 5.46640016 23.6720001 5.46640016 21.6524 5.46640016 20 7.11880019 20 9.13840023 20 11.2192003 21.6524 13.7284003 23.6720001 13.7284003 25.6916001 13.6672003 27.3440002 11.2192003 27.3440002 9.13840023zM0 19.7260005L0 22.0516005C0 22.4188005.306000006 22.6636005.612000013 22.6636005L4.10040009 22.6024005 4.10040009 20.8276005C4.16160009 18.5632004 4.8960001 16.4212004 6.18120013 14.7076004L5.07960011 14.7076004C3.73320008 14.7076004 2.44800005 15.2584004 1.46880003 16.2376004.550800012 17.1556004 0 18.3796004 0 19.7260005zM24.1740005 14.4628003L23.0724005 14.4628003C24.4188005 16.1152004 25.2756005 18.3184004 25.3368005 20.6440005L25.3368005 22.2964005 28.7640006 22.2352005C29.0700006 22.2352005 29.3760006 21.9292005 29.3760006 21.6232005L29.3760006 19.4200005C29.2536006 16.6660004 26.9280006 14.4016003 24.1740005 14.4628003z"
      />
    </svg>
  ),
  notifications: (
    <svg
      width="25px"
      height="30px"
      viewBox="0 0 25 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>notifications</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-1207.000000, -13.000000)"
          fill="var(--fill-color)"
        >
          <g transform="translate(1207.000000, 13.000000)">
            <path
              d="M24.8902521,25.251 L22.8722521,21.743 C21.9342521,20.179 21.4782521,18.389 21.4782521,16.27 L21.4782521,13.109 C21.4782521,9.058 18.4312521,5.555 14.4782521,4.648 L14.4782521,2 C14.4782521,0.897 13.5802521,0 12.4782521,0 C11.3752521,0 10.4782521,0.897 10.4782521,2 L10.4782521,4.648 C6.52525211,5.555 3.47825211,9.058 3.47825211,13.109 L3.47825211,16.27 C3.47825211,18.39 3.02225211,20.18 2.08025211,21.751 L0.0662521067,25.251 C-0.0227478933,25.405 -0.0217478933,25.596 0.0672521067,25.75 C0.157252107,25.905 0.321252107,26 0.500252107,26 L24.4562521,26 C24.6352521,26 24.8002521,25.905 24.8892521,25.75 C24.9792521,25.596 24.9792521,25.405 24.8902521,25.251"
              id="Fill-53"
            ></path>
            <path
              d="M12.4781521,30 C14.1371521,30 15.4851521,28.656 15.4971521,27 L9.45815211,27 C9.47015211,28.656 10.8191521,30 12.4781521,30"
              id="Fill-54"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  chat: (
    <svg
      width="30px"
      height="25px"
      viewBox="0 0 30 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>chat</title>
      <desc>Created with Sketch.</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-1260.000000, -16.000000)"
          fill="var(--fill-color)"
        >
          <g id="chat" transform="translate(1260.000000, 16.000000)">
            <path
              d="M2.814,15.26 L2.813,15.26 L2.814,15.26 L2.814,15.26 Z M10,16.5 C10,11.93 14.601,8.12 20.257,8.01 C20.409,8.01 20.552,7.94 20.644,7.82 C20.736,7.7 20.769,7.54 20.732,7.39 C19.64,3.04 15.432,0 10.5,0 C4.71,0 -1.70530257e-13,4.26 -1.70530257e-13,9.5 L0.005,9.65 C0.004,9.66 -1.70530257e-13,9.74 -1.70530257e-13,9.75 C-1.70530257e-13,11.84 0.807,13.82 2.362,15.5 L2.63,15.78 C3.008,16.17 3.425,16.53 3.874,16.86 L2.059,20.27 C1.95,20.47 1.995,20.72 2.167,20.88 C2.261,20.96 2.38,21 2.5,21 C2.599,21 2.697,20.97 2.783,20.92 L6.577,18.31 C7.57,18.67 8.633,18.89 9.739,18.97 C9.912,18.97 10.058,18.91 10.16,18.78 C10.262,18.66 10.298,18.49 10.255,18.34 C10.086,17.72 10,17.1 10,16.5 L10,16.5 Z"
              id="Fill-1494"
            ></path>
            <path
              d="M30,16.5 C30,12.37 25.738,9 20.5,9 C15.262,9 11,12.37 11,16.5 C11,20.64 15.262,24 20.5,24 C20.993,24 21.508,23.97 22.079,23.89 C22.532,23.83 22.981,23.75 23.415,23.64 L26.291,24.96 C26.358,24.99 26.43,25 26.5,25 C26.621,25 26.74,24.96 26.834,24.87 C26.982,24.74 27.037,24.53 26.974,24.34 L26.327,22.42 C28.635,21.01 30,18.82 30,16.5"
              id="Fill-1495"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  searchDark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18px"
      height="19px"
      viewBox="0 0 24 24"
    >
      <path
        fill="#AEB7BE"
        fillRule="evenodd"
        d="M18.637572,16.6132478 C19.9559616,14.8669438 20.7492727,12.6698585 20.7492727,10.2821066 C20.7492727,4.6126164 16.3196357,0 10.875269,0 C5.429637,0 1,4.6126164 1,10.2821066 C1,15.9503341 5.429637,20.5629505 10.875269,20.5629505 C13.0084789,20.5629505 14.9810022,19.845741 16.5979905,18.6436576 L21.3287568,23.5706845 C21.6045811,23.8573157 21.9651771,24 22.3270383,24 C22.6876343,24 23.0482303,23.8573157 23.3240546,23.5706845 C23.8744379,22.997422 23.8744379,22.0680802 23.3240546,21.493555 L18.637572,16.6132478 Z M3.82024018,10.2821066 C3.82024018,6.23265113 6.98589335,2.93828589 10.875269,2.93828589 C14.7646446,2.93828589 17.9277673,6.23265113 17.9277673,10.2821066 C17.9277673,14.3315621 14.7646446,17.6246646 10.875269,17.6246646 C6.98589335,17.6246646 3.82024018,14.3315621 3.82024018,10.2821066 L3.82024018,10.2821066 Z"
      />
    </svg>
  ),
  call: (
    <svg width="31px" height="30px" viewBox="0 0 31 30" version="1.1">
      <title>call</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Side-Nav"
          transform="translate(-13.000000, -349.000000)"
          fill="var(--fill-color)"
        >
          <g id="side-nav" transform="translate(0.500000, 0.000000)">
            <g id="call">
              <g transform="translate(13.000000, 349.000000)">
                <path
                  d="M29.49,5.63 C25.7,2.039 20.56,0.04 15,0.001 L14.82,8.8817842e-16 C9.19,8.8817842e-16 4.5,1.842 0.5,5.639 C0.18,5.959 0,6.389 0,6.851 C0,7.314 0.18,7.755 0.46,8.015 L3.41,11.584 C3.74,11.905 4.17,12.081 4.63,12.081 C5.09,12.081 5.51,11.909 5.81,11.61 C6.56,10.916 7.59,10.412 8.59,9.926 L9.16,9.647 C9.78,9.347 10,8.599 10,8 L10,3.866 C11.71,3.328 13.15,3 14.87,3 L14.99,3.001 C16.58,3.017 18.22,3.3 20,3.864 L20,7.792 C20,8.578 20.31,9.198 20.83,9.448 L21.49,9.77 C22.52,10.273 23.7,10.842 24.43,11.526 C25.09,12.148 26.17,12.171 26.87,11.457 L29.5,8.061 C29.82,7.741 30,7.311 30,6.851 C30,6.389 29.82,5.959 29.49,5.63"
                  id="Fill-2364"
                ></path>
                <path
                  d="M8.5,13 C7.12,13 6,14.122 6,15.5 C6,16.878 7.12,18 8.5,18 C9.88,18 11,16.878 11,15.5 C11,14.122 9.88,13 8.5,13"
                  id="Fill-2365"
                ></path>
                <path
                  d="M15.5,13 C14.12,13 13,14.122 13,15.5 C13,16.878 14.12,18 15.5,18 C16.88,18 18,16.878 18,15.5 C18,14.122 16.88,13 15.5,13"
                  id="Fill-2366"
                ></path>
                <path
                  d="M22.5,13 C21.12,13 20,14.122 20,15.5 C20,16.878 21.12,18 22.5,18 C23.88,18 25,16.878 25,15.5 C25,14.122 23.88,13 22.5,13"
                  id="Fill-2367"
                ></path>
                <path
                  d="M8.5,19 C7.12,19 6,20.122 6,21.5 C6,22.878 7.12,24 8.5,24 C9.88,24 11,22.878 11,21.5 C11,20.122 9.88,19 8.5,19"
                  id="Fill-2368"
                ></path>
                <path
                  d="M15.5,19 C14.12,19 13,20.122 13,21.5 C13,22.878 14.12,24 15.5,24 C16.88,24 18,22.878 18,21.5 C18,20.122 16.88,19 15.5,19"
                  id="Fill-2369"
                ></path>
                <path
                  d="M22.5,19 C21.12,19 20,20.122 20,21.5 C20,22.878 21.12,24 22.5,24 C23.88,24 25,22.878 25,21.5 C25,20.122 23.88,19 22.5,19"
                  id="Fill-2370"
                ></path>
                <path
                  d="M8.5,25 C7.12,25 6,26.122 6,27.5 C6,28.878 7.12,30 8.5,30 C9.88,30 11,28.878 11,27.5 C11,26.122 9.88,25 8.5,25"
                  id="Fill-2371"
                ></path>
                <path
                  d="M15.5,25 C14.12,25 13,26.122 13,27.5 C13,28.878 14.12,30 15.5,30 C16.88,30 18,28.878 18,27.5 C18,26.122 16.88,25 15.5,25"
                  id="Fill-2372"
                ></path>
                <path
                  d="M22.5,25 C21.12,25 20,26.122 20,27.5 C20,28.878 21.12,30 22.5,30 C23.88,30 25,28.878 25,27.5 C25,26.122 23.88,25 22.5,25"
                  id="Fill-2373"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  salezio: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="25pt"
      height="35pt"
      viewBox="0 0 25 35"
      version="1.1"
    >
      <g id="surface1">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'var(--fill-color)',
            fillOpacity: 1,
          }}
          d="M 0.144531 20.101562 L 6.957031 20.101562 L 6.957031 28.097656 L 0.144531 28.097656 Z M 0.144531 20.101562 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'var(--fill-color)',
            fillOpacity: 1,
          }}
          d="M 8.941406 12.089844 L 15.753906 12.089844 L 15.753906 28.097656 L 8.941406 28.097656 Z M 8.941406 12.089844 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'var(--fill-color)',
            fillOpacity: 1,
          }}
          d="M 17.738281 1.3125 L 24.554688 1.3125 L 24.554688 28.097656 L 17.738281 28.097656 Z M 17.738281 1.3125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#fff',
            fillOpacity: 1,
          }}
          d="M 23.449219 0.0742188 C 23.4375 0.0117188 23.390625 -0.0195312 23.359375 0.0117188 L 20.023438 3.882812 C 19.984375 3.925781 20.007812 4.035156 20.0625 4.042969 L 21.828125 3.996094 C 21.777344 4.199219 21.753906 4.203125 21.699219 4.429688 C 21.601562 4.777344 21.496094 5.148438 21.382812 5.546875 C 21.355469 5.648438 21.328125 5.75 21.296875 5.851562 C 21.265625 5.953125 21.234375 6.054688 21.203125 6.160156 C 21.136719 6.367188 21.070312 6.582031 21 6.800781 C 20.867188 7.242188 20.703125 7.683594 20.542969 8.15625 C 20.503906 8.273438 20.460938 8.394531 20.417969 8.515625 C 20.375 8.628906 20.332031 8.75 20.285156 8.867188 C 20.195312 9.105469 20.101562 9.347656 20.007812 9.597656 C 19.960938 9.722656 19.910156 9.84375 19.859375 9.964844 C 19.808594 10.085938 19.757812 10.210938 19.707031 10.335938 C 19.601562 10.582031 19.5 10.839844 19.390625 11.089844 C 19.277344 11.335938 19.160156 11.589844 19.046875 11.84375 C 18.988281 11.972656 18.933594 12.105469 18.871094 12.226562 C 18.808594 12.351562 18.746094 12.480469 18.683594 12.605469 C 18.558594 12.859375 18.433594 13.117188 18.300781 13.371094 C 18.167969 13.621094 18.03125 13.875 17.898438 14.128906 C 17.339844 15.132812 16.742188 16.144531 16.078125 17.089844 C 15.421875 18.039062 14.726562 18.964844 13.984375 19.808594 C 13.804688 20.027344 13.613281 20.226562 13.425781 20.433594 C 13.238281 20.632812 13.050781 20.847656 12.855469 21.035156 L 12.28125 21.613281 L 11.691406 22.160156 C 11.496094 22.347656 11.296875 22.511719 11.097656 22.683594 C 10.898438 22.851562 10.703125 23.023438 10.503906 23.179688 L 9.90625 23.648438 L 9.304688 24.082031 C 9.203125 24.152344 9.105469 24.230469 9.007812 24.296875 L 8.707031 24.492188 C 8.507812 24.621094 8.3125 24.757812 8.113281 24.878906 C 7.71875 25.117188 7.332031 25.359375 6.945312 25.5625 C 6.753906 25.664062 6.566406 25.773438 6.378906 25.867188 L 5.820312 26.140625 C 5.726562 26.1875 5.636719 26.234375 5.546875 26.273438 L 5.277344 26.394531 L 4.75 26.625 C 4.402344 26.769531 4.066406 26.894531 3.75 27.019531 L 2.835938 27.332031 L 2.023438 27.570312 C 1.773438 27.644531 1.539062 27.695312 1.328125 27.75 C 0.910156 27.859375 0.574219 27.917969 0.347656 27.96875 L 0 28.039062 L 0.351562 27.996094 C 0.582031 27.96875 0.921875 27.941406 1.347656 27.867188 C 1.5625 27.832031 1.800781 27.800781 2.058594 27.75 L 2.886719 27.582031 L 3.820312 27.351562 C 4.148438 27.253906 4.492188 27.15625 4.851562 27.042969 L 5.394531 26.859375 L 5.671875 26.761719 C 5.765625 26.730469 5.859375 26.691406 5.957031 26.65625 L 6.535156 26.429688 C 6.730469 26.351562 6.925781 26.257812 7.125 26.171875 C 7.523438 26.003906 7.925781 25.792969 8.339844 25.589844 C 8.546875 25.488281 8.75 25.367188 8.960938 25.253906 L 9.273438 25.082031 C 9.378906 25.023438 9.480469 24.957031 9.585938 24.894531 L 10.214844 24.507812 L 10.847656 24.085938 C 11.058594 23.949219 11.265625 23.792969 11.476562 23.640625 C 11.6875 23.484375 11.898438 23.335938 12.105469 23.164062 L 12.730469 22.664062 L 13.347656 22.125 C 13.558594 21.953125 13.757812 21.753906 13.960938 21.5625 C 14.160156 21.375 14.363281 21.183594 14.558594 20.976562 C 15.359375 20.1875 16.117188 19.304688 16.835938 18.390625 C 17.5625 17.480469 18.222656 16.496094 18.84375 15.507812 L 19.300781 14.761719 C 19.449219 14.515625 19.585938 14.253906 19.726562 14.007812 C 19.796875 13.882812 19.867188 13.757812 19.9375 13.632812 C 20.007812 13.507812 20.070312 13.378906 20.140625 13.253906 L 20.527344 12.5 C 20.65625 12.25 20.773438 11.996094 20.890625 11.746094 L 21.066406 11.378906 C 21.125 11.253906 21.183594 11.132812 21.238281 11.007812 C 21.34375 10.761719 21.453125 10.515625 21.558594 10.277344 C 21.609375 10.15625 21.660156 10.039062 21.710938 9.917969 C 21.761719 9.800781 21.808594 9.679688 21.855469 9.5625 C 22.042969 9.085938 22.234375 8.636719 22.390625 8.1875 C 22.472656 7.964844 22.550781 7.75 22.628906 7.539062 C 22.667969 7.433594 22.703125 7.328125 22.742188 7.226562 C 22.777344 7.121094 22.816406 7.019531 22.84375 6.917969 C 23.039062 6.238281 23.054688 6.105469 23.136719 5.742188 C 23.238281 5.292969 23.40625 4.625 23.492188 4.34375 L 24.917969 4.996094 C 24.964844 5.054688 25.023438 5.003906 25.003906 4.917969 Z M 23.449219 0.0742188 "
        />
      </g>
    </svg>
  ),
  calendar: (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Side-Nav"
          transform="translate(-14.000000, -237.000000)"
          fill="var(--fill-color)"
        >
          <g id="side-nav" transform="translate(0.500000, 0.000000)">
            <g id="tasks">
              <g transform="translate(13.500000, 237.000000)">
                <path
                  d="M11.0688,23.9989 C11.0468,23.9959 11.0238,23.9939 10.9998,23.9939 C9.8968,23.9939 8.9998,23.0969 8.9998,21.9939 C8.9998,21.7179 8.7768,21.4939 8.4998,21.4939 C8.2238,21.4939 7.9998,21.7179 7.9998,21.9939 C7.9998,23.6199 9.3008,24.9479 10.9158,24.9929 C10.9438,24.9979 10.9708,24.9999 10.9998,24.9999 C12.6418,24.9999 13.9798,23.6799 13.9998,22.0499 L13.9998,22.0349 L13.9998,22.0239 L13.9998,22.0139 L13.9998,21.9989 C13.9878,20.9699 13.4668,20.0829 12.6668,19.5649 C13.4698,19.0149 13.9998,18.0759 13.9998,16.9969 C13.9998,15.3439 12.6548,13.9999 10.9998,13.9999 C9.3458,13.9999 7.9998,15.3439 7.9998,16.9969 C7.9998,17.2729 8.2238,17.4969 8.4998,17.4969 C8.7768,17.4969 8.9998,17.2729 8.9998,16.9969 C8.9998,15.8959 9.8968,14.9999 10.9998,14.9999 C12.1028,14.9999 12.9998,15.8959 12.9998,17.0399 C12.9998,18.1469 12.0838,19.0809 10.9998,19.0809 L9.7498,19.0809 C9.4738,19.0809 9.2498,19.3049 9.2498,19.5809 C9.2498,19.8569 9.4738,20.0809 9.7498,20.0809 L10.9998,20.0809 C12.1178,20.0809 12.9938,20.9339 12.9998,22.0239 C12.9938,23.0919 12.1358,23.9629 11.0688,23.9989"
                  id="Fill-650"
                ></path>
                <path
                  d="M17.5,24 C17.224,24 17,24.224 17,24.5 C17,24.776 17.224,25 17.5,25 L21.5,25 C21.776,25 22,24.776 22,24.5 C22,24.224 21.776,24 21.5,24 L20,24 L20,14.5 C20,14.298 19.878,14.115 19.691,14.038 C19.506,13.959 19.29,14.003 19.147,14.146 L17.147,16.146 C16.951,16.342 16.951,16.658 17.147,16.853 C17.342,17.049 17.658,17.049 17.853,16.853 L19,15.707 L19,24 L17.5,24 Z"
                  id="Fill-651"
                ></path>
                <path
                  d="M29,26.5 C29,27.879 27.879,29 26.5,29 L3.5,29 C2.122,29 1,27.879 1,26.5 L1,10 L29,10 L29,26.5 Z M26.5,3 L22,3 L22,0.5 C22,0.224 21.776,0 21.5,0 C21.224,0 21,0.224 21,0.5 L21,3 L21,5.5 C21,5.776 20.776,6 20.5,6 C20.224,6 20,5.776 20,5.5 L20,3 L9,3 L9,0.5 C9,0.224 8.776,0 8.5,0 C8.224,0 8,0.224 8,0.5 L8,3 L8,5.5 C8,5.776 7.776,6 7.5,6 C7.224,6 7,5.776 7,5.5 L7,3 L3.5,3 C1.57,3 0,4.57 0,6.5 L0,26.5 C0,28.43 1.57,30 3.5,30 L26.5,30 C28.43,30 30,28.43 30,26.5 L30,6.5 C30,4.57 28.43,3 26.5,3 L26.5,3 Z"
                  id="Fill-652"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  performance: (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Side-Nav"
          transform="translate(-14.000000, -293.000000)"
          fill="var(--fill-color)"
        >
          <g id="side-nav" transform="translate(0.500000, 0.000000)">
            <g id="Performance">
              <g transform="translate(0.000000, 280.000000)">
                <g id="performance" transform="translate(13.500000, 13.000000)">
                  <path
                    d="M29.5,29 L28,29 L28,10.5 C28,10.224 27.776,10 27.5,10 L23.5,10 C23.224,10 23,10.224 23,10.5 L23,29 L21,29 L21,18.5 C21,18.224 20.776,18 20.5,18 L16.5,18 C16.224,18 16,18.224 16,18.5 L16,29 L14,29 L14,15.5 C14,15.224 13.776,15 13.5,15 L9.5,15 C9.224,15 9,15.224 9,15.5 L9,29 L7,29 L7,21.5 C7,21.224 6.776,21 6.5,21 L2.5,21 C2.224,21 2,21.224 2,21.5 L2,29 L0.5,29 C0.224,29 0,29.224 0,29.5 C0,29.776 0.224,30 0.5,30 L2.5,30 L6.5,30 L9.5,30 L13.5,30 L16.5,30 L20.5,30 L23.5,30 L27.5,30 L29.5,30 C29.776,30 30,29.776 30,29.5 C30,29.224 29.776,29 29.5,29"
                    id="Fill-481"
                  ></path>
                  <path
                    d="M4.5,16 C5.878,16 7,14.878 7,13.5 C7,13.059 6.875,12.65 6.674,12.29 L9.977,9.469 C10.4,9.797 10.924,10 11.5,10 C12.349,10 13.098,9.573 13.55,8.924 L16.052,9.994 C16.018,10.157 16,10.327 16,10.5 C16,11.878 17.121,13 18.5,13 C19.879,13 21,11.878 21,10.5 C21,9.932 20.802,9.413 20.481,8.992 L24.273,4.665 C24.637,4.872 25.052,5 25.5,5 C26.879,5 28,3.878 28,2.5 C28,1.122 26.879,0 25.5,0 C24.121,0 23,1.122 23,2.5 C23,3.069 23.198,3.587 23.519,4.008 L19.727,8.335 C19.363,8.128 18.948,8 18.5,8 C17.651,8 16.902,8.427 16.45,9.076 L13.948,8.006 C13.982,7.843 14,7.673 14,7.5 C14,6.122 12.878,5 11.5,5 C10.122,5 9,6.122 9,7.5 C9,7.941 9.125,8.35 9.326,8.71 L6.023,11.531 C5.6,11.203 5.076,11 4.5,11 C3.122,11 2,12.122 2,13.5 C2,14.878 3.122,16 4.5,16"
                    id="Fill-482"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  warningTriangle: (
    <svg
      version="1.1"
      id="fi_564619"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 511.999 511.999"
    >
      <path
        style={{ fill: '#E50027' }}
        d="M501.449,368.914L320.566,66.207C306.751,43.384,282.728,29.569,256,29.569
        s-50.752,13.815-64.567,36.638L10.55,368.914c-13.812,23.725-14.113,51.954-0.599,75.678c13.513,23.723,37.836,37.838,65.165,37.838
        h361.766c27.329,0,51.653-14.115,65.165-37.838C515.563,420.868,515.262,392.639,501.449,368.914z"
      ></path>
      <path
        style={{ fill: '#C1001F' }}
        d="M502.049,444.592c-13.513,23.723-37.836,37.838-65.165,37.838H256V29.57
        c26.727,0,50.752,13.815,64.567,36.638L501.45,368.915C515.262,392.639,515.563,420.868,502.049,444.592z"
      ></path>
      <path
        style={{ fill: '#FD003A' }}
        d="M75.109,452.4c-16.628,0-30.851-8.27-39.063-22.669c-8.211-14.414-8.065-31.087,0.469-45.72
        L217.23,81.549c8.27-13.666,22.816-21.951,38.769-21.951s30.5,8.284,38.887,22.157l180.745,302.49
        c8.388,14.4,8.534,31.072,0.322,45.485c-8.211,14.4-22.435,22.669-39.063,22.669H75.109V452.4z"
      ></path>
      <path
        style={{ fill: '#E50027' }}
        d="M436.891,452.4c16.628,0,30.851-8.27,39.063-22.669c8.211-14.414,8.065-31.087-0.322-45.485
        L294.886,81.754c-8.388-13.871-22.933-22.157-38.887-22.157V452.4H436.891z"
      ></path>
      <path
        style={{ fill: '#E1E4FB' }}
        d="M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03s-30.031-13.514-30.031-30.03V152.095
        c0-16.517,13.514-30.031,30.031-30.031S286.03,135.578,286.03,152.095z"
      ></path>
      <path
        style={{ fill: '#C5C9F7' }}
        d="M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03V122.064
        C272.516,122.064,286.03,135.578,286.03,152.095z"
      ></path>
      <path
        style={{ fill: '#E1E4FB' }}
        d="M256,332.278c-24.926,0-45.046,20.119-45.046,45.046c0,24.924,20.119,45.046,45.046,45.046
        s45.046-20.121,45.046-45.046C301.046,352.398,280.925,332.278,256,332.278z"
      ></path>
      <path
        style={{ fill: '#C5C9F7' }}
        d="M301.046,377.323c0,24.924-20.119,45.046-45.046,45.046v-90.091
        C280.925,332.278,301.046,352.398,301.046,377.323z"
      ></path>
    </svg>
  ),
  sprint: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.45 25.45"
      width="25.45"
      height="25.45"
    >
      <g id="ee2e70d8-43a7-4bb4-9a18-079cb1903015" data-name="Layer 2">
        <g id="b6e80179-3570-49dc-afb5-d42daf86848f" data-name="Layer 1">
          <g id="a5c471c3-4e61-4ddd-9188-f4c2a783667e" data-name="Group 454">
            <g id="b1decdfe-be35-4f45-8e53-803b868a1912" data-name="JRDkwO.tif">
              <g
                id="b5eeff83-d72b-4487-b8a7-96220132df7d"
                data-name="Group 200"
              >
                <path
                  id="a903dcba-9c78-4207-a5d3-589c17fb0665"
                  data-name="Path 33"
                  d="M25.45,13.43H24.1l-2.43,0-.39,0a.93.93,0,0,1-.73-.58c-.27-.6-.51-1.21-.76-1.82l-.86-2a1.58,1.58,0,0,0-.29-.39.17.17,0,0,0-.25,0h0c-.63.42-1.26.82-1.88,1.25L14.42,11.3l-.12.1.08.12,3.78,5.27a1.57,1.57,0,0,1,.29.54A1.13,1.13,0,0,1,18,18.52a1,1,0,0,1-.62.21H5V16.4h9.86l0,0-.1-.15-3.31-4.61c-.37-.51-.7-1-1.07-1.53a1.07,1.07,0,0,1,.22-1.31c.73-.52,1.46-1,2.2-1.52L14.65,6,14.77,6l-.63-.42a.44.44,0,0,0-.16,0H7V3.13h.14l6.75,0c.18,0,.36,0,.54,0a1.23,1.23,0,0,1,.72.23L20.47,7a1,1,0,0,1,.43.53c.48,1.15,1,2.3,1.43,3.46a.18.18,0,0,0,.22.14h2.9Z"
                  style={{
                    fill: 'var(--fill-color)',
                  }}
                />
                <path
                  id="ab1fbb55-c62e-412e-ad68-1fd9c9847934"
                  data-name="Path 34"
                  d="M20.83,0a5.27,5.27,0,0,1,.68.19,2.44,2.44,0,1,1-3.33,2A2.48,2.48,0,0,1,20.27,0l.12,0Z"
                  fill="var(--fill-color)"
                  style={{
                    fill: 'var(--fill-color)',
                  }}
                />
                <path
                  id="b187c406-2767-44d9-88b0-e8bfed7e0978"
                  data-name="Path 35"
                  d="M7.32,25.45l-1.2-1.22-.46-.45,4-4,1.67,1.67-.09.09L7.44,25.34l-.09.11Z"
                  fill="var(--fill-color)"
                  style={{
                    fill: 'var(--fill-color)',
                  }}
                />
                <path
                  id="a6a53219-a3fa-43c5-b003-c51269e585d7"
                  data-name="Path 36"
                  d="M0,7H8V8.6H0Z"
                  fill="var(--fill-color)"
                  style={{
                    fill: 'var(--fill-color)',
                  }}
                />
                <path
                  id="bbff7efc-6f06-48f2-9dbf-f08d9e7e5cee"
                  data-name="Path 37"
                  d="M0,9.84H8v1.53H0Z"
                  fill="var(--fill-color)"
                  style={{
                    fill: 'var(--fill-color)',
                  }}
                />
                <path
                  id="af6552af-1a16-4a2a-b4b2-6fe0396dd515"
                  data-name="Path 38"
                  d="M0,12.67H8V14.2H0Z"
                  fill="var(--fill-color)"
                  style={{
                    fill: 'var(--fill-color)',
                  }}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  'sprint-config': (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.26 24.29"
      width="26.26"
      height="24.29"
    >
      <g id="e9dc97ac-b90d-40e1-b780-919306b4de3c" data-name="Layer 2">
        <g id="a8140a85-0bb6-4766-b14e-3d7315ea44c9" data-name="Layer 1">
          <path
            d="M24.41,17.4l0-.28a4.71,4.71,0,0,0,0-.53,4.89,4.89,0,0,0,0-.54l0-.28,1.76-1.34a.28.28,0,0,0,0-.35l-1.61-2.7a.31.31,0,0,0-.37-.12l-2,.8L22,11.91a5.82,5.82,0,0,0-1-.56l-.25-.11L20.45,9.1a.3.3,0,0,0-.3-.21H17a.31.31,0,0,0-.3.25l-.31,2.12-.26.11a5.87,5.87,0,0,0-1,.55l-.22.16-2.05-.81a.3.3,0,0,0-.35.13l-1.6,2.69a.28.28,0,0,0,.07.36l1.74,1.33,0,.28a4.71,4.71,0,0,0,0,.53,4.89,4.89,0,0,0,0,.54l0,.28-1.76,1.34a.28.28,0,0,0,0,.35l1.61,2.71a.3.3,0,0,0,.37.11l2-.79.21.15a6.35,6.35,0,0,0,1,.56l.25.11.31,2.13a.3.3,0,0,0,.29.21h3.2a.32.32,0,0,0,.31-.25l.3-2.11.25-.11a5.78,5.78,0,0,0,1-.55l.22-.16,2.06.81a.33.33,0,0,0,.35-.13l1.6-2.69a.31.31,0,0,0-.07-.38Zm-5.86,2.23a2.45,2.45,0,0,1-2.45-2.45,2.46,2.46,0,0,1,2.45-2.46,2.46,2.46,0,0,1,0,4.91Z"
            style={{ fill: 'var(--fill-color)' }}
          />
          <path
            d="M10,13.57l.15-.24H4.08v1.91h6.25A1.29,1.29,0,0,1,10,13.57Z"
            style={{ fill: 'var(--fill-color)' }}
          />
          <path
            d="M12.37,10.32l-.69-1-.06-.09.1-.08c.57-.4,1.13-.81,1.7-1.2s1-.68,1.52-1h0a.15.15,0,0,1,.21,0,1.72,1.72,0,0,1,.23.32c.17.39.34.78.5,1.17A1.3,1.3,0,0,1,17,7.89h.77L17,6.09a.87.87,0,0,0-.35-.43l-4.31-2.9a.94.94,0,0,0-.58-.19c-.15,0-.29,0-.44,0H5.7V4.49h5.66a.29.29,0,0,1,.13,0l.52.35-.1.06-1.48,1c-.6.4-1.19.81-1.79,1.23a.88.88,0,0,0-.18,1.06c.3.41.58.84.87,1.25l1.74,2.41.56-.95A1.32,1.32,0,0,1,12.37,10.32Z"
            style={{ fill: 'var(--fill-color)' }}
          />
          <path
            d="M16,3.84A2,2,0,1,0,17.49.15,4.94,4.94,0,0,0,16.94,0h-.36l-.09,0a2,2,0,0,0-1.7,1.74A2,2,0,0,0,16,3.84Z"
            style={{ fill: 'var(--fill-color)' }}
          />
          <path
            d="M4.61,19.33c.11.12.24.25.37.37l1,1H6a.27.27,0,0,1,.07-.08l3.1-3.1.07-.08L7.86,16.08Z"
            style={{ fill: 'var(--fill-color)' }}
          />
          <polygon
            points="6.54 5.7 0.13 5.7 0 5.7 0 6.99 6.54 6.99 6.54 5.7"
            style={{ fill: 'var(--fill-color)' }}
          />
          <path d="M0,8V9.25H6.54V8H0Z" style={{ fill: 'var(--fill-color)' }} />
          <path
            d="M6.54,11.55V10.3H0v1.25H6.54Z"
            style={{ fill: 'var(--fill-color)' }}
          />
        </g>
      </g>
    </svg>
  ),
  pointer: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="var(--fill-color)" fillRule="evenodd">
        <path d="M18.3868789,7.42354142 L16.077819,9.72725128 C16.734799,10.7972512 17.1199989,12.0384511 17.1199989,13.3759511 C17.1199989,17.2065508 13.9998791,20.3309506 10.1649994,20.3309506 C6.33011961,20.3309506 3.2099998,17.2065508 3.2099998,13.3759511 C3.2099998,9.54535129 6.33011961,6.42095149 10.1649994,6.42095149 C11.5014293,6.42095149 12.7469092,6.80615146 13.8083491,7.46313142 L16.117409,5.15407156 C14.4417891,3.93748164 12.3895292,3.21095169 10.1649994,3.21095169 C4.56033972,3.21095169 0,7.7712914 0,13.3759511 C0,18.9827507 4.56033972,23.5409504 10.1649994,23.5409504 C15.769659,23.5409504 20.3299987,18.9827507 20.3299987,13.3759511 C20.3299987,11.1503512 19.6034688,9.09595132 18.3868789,7.42354142" />
        <path d="M12.8025492,13.0121511 C12.8196692,13.1298511 12.8399992,13.2475511 12.8399992,13.3759511 C12.8399992,14.852551 11.6405293,16.0509509 10.1649994,16.0509509 C8.68946946,16.0509509 7.48999953,14.852551 7.48999953,13.3759511 C7.48999953,11.8993511 8.68946946,10.7009512 10.1649994,10.7009512 C10.2912594,10.7009512 10.4121694,10.7223512 10.5330793,10.7330512 L13.0304592,8.24102137 C12.1819492,7.7648714 11.2050393,7.49095142 10.1649994,7.49095142 C6.92075957,7.49095142 4.27999973,10.1338513 4.27999973,13.3759511 C4.27999973,16.6180508 6.92075957,19.2609507 10.1649994,19.2609507 C13.4092392,19.2609507 16.049999,16.6180508 16.049999,13.3759511 C16.049999,12.3380511 15.776079,11.3643512 15.299929,10.5083512 L12.8025492,13.0121511" />
        <path d="M19.2599988,4.28095162 L20.6435087,4.28095162 L21.7135086,3.21095169 L20.8649987,3.21095169 C20.5696787,3.21095169 20.3299987,2.9712717 20.3299987,2.67595172 L20.3299987,1.82744177 L19.2599988,2.89744171 L19.2599988,4.28095162 L19.2599988,4.28095162 Z M10.1649994,13.910951 C10.0280394,13.910951 9.89107938,13.857451 9.78621939,13.750451 C9.5775694,13.547151 9.5775694,13.2047511 9.78621939,13.0014511 L18.1899989,4.5944616 L18.1899989,2.67595172 C18.1899989,2.53364173 18.2467089,2.39775174 18.3462189,2.29717174 L20.4862187,0.157171877 C20.6402987,0.00416188614 20.8714187,-0.0429181109 21.0693687,0.0416118838 C21.2694587,0.124001879 21.3999987,0.319811866 21.3999987,0.535951853 L21.3999987,2.14095175 L23.0049986,2.14095175 C23.2211386,2.14095175 23.4169485,2.27149174 23.4993385,2.47158173 C23.5817285,2.67167172 23.5357185,2.90065171 23.3837785,3.0536617 L21.2437787,5.19366156 C21.1431987,5.29424156 21.0073087,5.35095155 20.8649987,5.35095155 L18.9464888,5.35095155 L10.5437793,13.750451 C10.4389193,13.857451 10.3019594,13.910951 10.1649994,13.910951 L10.1649994,13.910951 Z" />
      </g>
    </svg>
  ),
  filter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
    >
      <path
        fill="var(--fill-color)"
        d="M33.6014904,9 L16.3985096,9 C16.0441858,9 15.8667398,9.43258566 16.1172846,9.68558269 L22.3552431,15.9845949 C22.8773412,16.5118031 23.1706535,17.2268522 23.1706535,17.9724378 L23.1706535,25.4949216 C23.1706535,25.6234105 23.2315369,25.7441407 23.334443,25.8197146 L26.1977097,27.9224708 C26.4605862,28.1155252 26.8293458,27.925906 26.8293458,27.5976795 L26.8293458,17.972438 C26.8293458,17.2268524 27.1226581,16.5118033 27.6447563,15.9845951 L33.8827148,9.68558288 C34.1332609,9.43258566 33.9558138,9 33.6014904,9 Z"
        transform="translate(-16 -9)"
      />
    </svg>
  ),
  cloudDownload: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="25pt"
      height="25pt"
      viewBox="0 0 25 25"
      version="1.1"
    >
      <g id="surface1">
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'var(--fill-color)',
            fillOpacity: 1,
          }}
          d="M 22.984375 13.679688 C 23.128906 13.132812 23.210938 12.5625 23.210938 11.972656 C 23.210938 8.269531 20.214844 5.277344 16.519531 5.277344 C 15.566406 5.277344 14.664062 5.476562 13.847656 5.835938 C 13.027344 3.929688 11.132812 2.597656 8.929688 2.597656 C 5.972656 2.597656 3.574219 4.996094 3.574219 7.953125 C 3.574219 8.15625 3.613281 8.339844 3.632812 8.535156 C 1.488281 9.527344 0 11.683594 0 14.203125 C 0 17.65625 2.796875 20.453125 6.25 20.453125 L 21.429688 20.453125 C 23.402344 20.453125 25 18.859375 25 16.882812 C 25 15.46875 24.175781 14.261719 22.984375 13.679688 Z M 12.5 17.773438 L 8.039062 13.3125 L 10.71875 13.3125 L 10.71875 8.847656 L 14.289062 8.847656 L 14.289062 13.3125 L 16.96875 13.3125 Z M 12.5 17.773438 "
        />
      </g>
    </svg>
  ),
  noNotifications: (
    <svg
      width="86px"
      height="85px"
      viewBox="0 0 86 85"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>no-notifications-illustration</title>
      <g
        id="Dashboard-/-Notifications"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Notifications---Empty"
          transform="translate(-969.000000, -262.000000)"
        >
          <g
            id="notifications-side"
            transform="translate(709.000000, 66.000000)"
          >
            <g
              id="no-ntifications"
              transform="translate(120.000000, 193.000000)"
            >
              <g
                id="no-notifications-illustration"
                transform="translate(139.000000, 0.000000)"
              >
                <g transform="translate(1.911111, 4.500000)">
                  <g
                    id="application-icons/notifications"
                    stroke="#DADEE3"
                    strokeWidth="4"
                  >
                    <g transform="translate(0.646243, 0.000000)">
                      <path
                        d="M34.180167,7.80867052 C36.7136375,7.80867052 39.1546456,8.16746775 41.4699048,8.80494243 C41.5216838,8.47749642 41.5771612,8.1500504 41.5771612,7.80867052 C41.5771612,3.95943815 38.2670063,0.841734104 34.180167,0.841734104 C30.0933277,0.841734104 26.7831728,3.95943815 26.7831728,7.80867052 C26.7831728,8.1500504 26.8386502,8.47749642 26.8904292,8.80494243 C29.2056884,8.16746775 31.6466965,7.80867052 34.180167,7.80867052 L34.180167,7.80867052 Z"
                        id="Stroke-390"
                      ></path>
                      <path
                        d="M66.9721519,63.2525956 C63.8432234,56.7628943 56.3722592,46.1278658 56.3722592,32.193993 C56.3722592,20.0262386 49.9294772,9.9415981 38.1423669,8.10581036 C23.9290425,5.89380805 11.5242832,17.343968 11.9681029,30.9051098 C12.445209,45.4764573 4.67466659,56.5643366 1.44957711,63.2525956 C-0.196254099,66.6629109 2.46666382,70.5121433 6.44254821,70.5121433 L61.9791808,70.5121433 C65.9550652,70.5121433 68.6179831,66.6629109 66.9721519,63.2525956 L66.9721519,63.2525956 Z"
                        id="Stroke-392"
                      ></path>
                      <path
                        d="M9.52228676,63.5441618 C9.71091011,63.1923316 9.90693046,62.8300509 10.1066493,62.4573198 C13.8014479,55.6088213 19.3861785,45.2594372 19.3861785,32.192948 C19.3861785,23.7734053 23.273299,14.7756069 34.180167,14.7756069"
                        id="Stroke-394"
                      ></path>
                      <path
                        d="M45.2756583,70.5110983 C45.2756583,76.2832051 40.3085767,80.9615029 34.180167,80.9615029 C28.0517573,80.9615029 23.0846757,76.2832051 23.0846757,70.5110983"
                        id="Stroke-396"
                      ></path>
                    </g>
                  </g>
                  <g id="Group-11" transform="translate(43.955556, 43.200000)">
                    <path
                      d="M0,18 C0,8.0568 8.55795556,0 19.1111111,0 C29.6680889,0 38.2222222,8.0568 38.2222222,18 C38.2222222,27.9432 29.6680889,36 19.1111111,36 C8.55795556,36 0,27.9432 0,18 Z"
                      id="Stroke-6654-Copy"
                      stroke="#FFFFFF"
                      strokeWidth="3.96"
                      fill="#FFFFFF"
                    ></path>
                    <g
                      id="Group-8"
                      transform="translate(1.911111, 1.800000)"
                      stroke="#DADEE3"
                      strokeWidth="3.6"
                    >
                      <path
                        d="M0,16.2 C0,7.25112 7.70216,0 17.2,0 C26.70128,0 34.4,7.25112 34.4,16.2 C34.4,25.14888 26.70128,32.4 17.2,32.4 C7.70216,32.4 0,25.14888 0,16.2 Z"
                        id="Stroke-6654"
                        fill="#FFFFFF"
                      ></path>
                      <line
                        x1="5.038912"
                        y1="4.745952"
                        x2="29.363152"
                        y2="27.652752"
                        id="Stroke-6656"
                      ></line>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  'call-phone': (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="var(--fill-color)"
        fillRule="evenodd"
        d="M19.7293976,10.1353755 C17.0763976,7.75742666 13.4783976,6.43369518 9.58639759,6.4078695 L9.46039759,6.40720731 C5.51939759,6.40720731 2.23639759,7.62697388 -0.563602413,10.1413353 C-0.787602413,10.3532383 -0.913602413,10.6379829 -0.913602413,10.9439178 C-0.913602413,11.250515 -0.787602413,11.5425438 -0.591602413,11.714715 L1.47339759,14.0780955 C1.70439759,14.2906607 2.00539759,14.4072073 2.32739759,14.4072073 C2.64939759,14.4072073 2.94339759,14.2933095 3.15339759,14.0953126 C3.67839759,13.635748 4.39939759,13.3020008 5.09939759,12.9801731 L5.49839759,12.7954202 C5.93239759,12.5967612 6.08639759,12.1014379 6.08639759,11.704782 L6.08639759,8.96726028 C7.28339759,8.61099838 8.29139759,8.39379782 9.49539759,8.39379782 L9.57939759,8.39446002 C10.6923976,8.40505517 11.8403976,8.59245687 13.0863976,8.96593589 L13.0863976,11.5670451 C13.0863976,12.0875318 13.3033976,12.4980938 13.6673976,12.663643 L14.1293976,12.8768704 C14.8503976,13.2099554 15.6763976,13.5867454 16.1873976,14.0396881 C16.6493976,14.4515745 17.4053976,14.466805 17.8953976,13.9939965 L19.7363976,11.745176 C19.9603976,11.533273 20.0863976,11.2485284 20.0863976,10.9439178 C20.0863976,10.6379829 19.9603976,10.3532383 19.7293976,10.1353755"
        transform="rotate(-133 9.586 10.407)"
      />
    </svg>
  ),
  hangup: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="var(--fill-color)"
        fillRule="evenodd"
        d="M10,6.0006622 L9.88,6 C6.12666667,6 3,7.21976658 0.333333333,9.73412797 C0.12,9.94603096 0,10.2307756 0,10.5367105 C0,10.8433077 0.12,11.1353365 0.306666667,11.3075077 L2.27333333,13.6708882 C2.49333333,13.8834534 2.78,14 3.08666667,14 C3.39333333,14 3.67333333,13.8861021 3.87333333,13.6881053 C4.37333333,13.2285407 5.06,12.8947935 5.72666667,12.5729658 L6.10666667,12.3882129 C6.52,12.1895538 6.66666667,11.6942306 6.66666667,11.2975747 L6.66666667,8.56005298 C7.80666667,8.20379108 8.76666667,7.98659051 9.91333333,7.98659051 L9.99333333,7.98725271 C11.0533333,7.99784786 12.1466667,8.18524957 13.3333333,8.55872858 L13.3333333,11.1598378 C13.3333333,11.6803245 13.54,12.0908865 13.8866667,12.2564357 L14.3266667,12.4696631 C15.0133333,12.8027481 15.8,13.1795381 16.2866667,13.6324808 C16.7266667,14.0443672 17.4466667,14.0595977 17.9133333,13.5867892 L19.6666667,11.3379687 C19.88,11.1260657 20,10.8413211 20,10.5367105 C20,10.2307756 19.88,9.94603096 19.66,9.7281682 C17.1333333,7.35021935 13.7066667,6.02648787 10,6.0006622 Z"
      />
    </svg>
  ),
  mute: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        fill="var(--fill-color)"
        fillRule="evenodd"
        transform="translate(.3 2)"
      >
        <path d="M9.11820026,0.0229647195 C9.01828226,-0.0207152818 8.90253026,-0.00105928122 8.82336025,0.0731967209 L3.6079681,4.91403286 L1.36500004,4.91403286 C0.612066018,4.91403286 0,5.52664488 0,6.2790329 L0,10.101033 C0,10.853967 0.612066018,11.466033 1.36500004,11.466033 L3.6079681,11.466033 L8.82336025,16.3074152 C8.87468426,16.3554632 8.94129626,16.3800332 9.00900026,16.3800332 C9.04558226,16.3800332 9.08325626,16.3729352 9.11820026,16.3576472 C9.21757227,16.3139672 9.28200027,16.2162332 9.28200027,16.1070332 L9.28200027,0.273032727 C9.28200027,0.164924724 9.21757227,0.0666447207 9.11820026,0.0229647195" />
        <path
          stroke="var(--fill-color)"
          strokeWidth=".5"
          d="M15.9846965,8.19009123 L19.0029845,5.1718786 C19.1456726,5.02919417 19.1456726,4.79915191 19.0029845,4.65646747 C18.8610245,4.51451102 18.6309765,4.51451102 18.4890165,4.65646747 L15.4700004,7.67540809 L12.4509844,4.65646747 C12.3090244,4.51451102 12.0789763,4.51451102 11.9370163,4.65646747 C11.7943283,4.79915191 11.7943283,5.02919417 11.9370163,5.1718786 L14.9553044,8.19009123 L11.9370163,11.2083039 C11.7943283,11.3509883 11.7943283,11.5810306 11.9370163,11.723715 C12.0076323,11.7943292 12.1008163,11.8300003 12.1940004,11.8300003 C12.2871844,11.8300003 12.3803684,11.7943292 12.4509844,11.723715 L15.4700004,8.70477438 L18.4890165,11.723715 C18.5596325,11.7943292 18.6528165,11.8300003 18.7460005,11.8300003 C18.8391845,11.8300003 18.9323685,11.7943292 19.0029845,11.723715 C19.1456726,11.5810306 19.1456726,11.3509883 19.0029845,11.2083039 L15.9846965,8.19009123 Z"
        />
      </g>
    </svg>
  ),
  chevron: (
    <>
      <svg
        width="6px"
        height="10px"
        viewBox="0 0 6 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <title>116E3F8E-39C0-4175-892A-6C504BE87F40</title>
        <desc>Created with sketchtool.</desc>
        <g
          id="Lead-Management-/-Agent"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Lead-List---Actions-Dropdown"
            transform="translate(-765.000000, -835.000000)"
            fill="var(--fill-color)"
          >
            <g id="Group-8" transform="translate(80.000000, 804.000000)">
              <g
                id="Right-Chevron-Copy"
                transform="translate(682.000000, 30.000000)"
              >
                <path
                  d="M7.10707334,10.3497115 L3.67507334,6.92278846 C3.37507334,6.62278846 3.06722648,5.63913462 3.75607334,4.93586538 L7.05607334,1.64048077 C7.39807334,1.29894231 7.95232334,1.29894231 8.29357334,1.64048077 C8.63557334,1.98125 8.63557334,2.53509615 8.29357334,2.87586538 L5.24557334,5.92048077 L8.39332334,9.06432692 C8.74882334,9.41894231 8.74882334,9.99509615 8.39332334,10.3497115 C8.03857334,10.7043269 7.46182334,10.7043269 7.10707334,10.3497115 Z"
                  id="Shape-Copy"
                  transform="translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) "
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  ),
  voicemail: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="11"
        viewBox="0 0 24 11"
      >
        <path
          fill="var(--fill-color)"
          fillRule="evenodd"
          d="M20.2334568 2.86944011L15.1387366 5.53392021C14.6634246 5.74864022 14.1627365 5.86576022 13.6659525 5.86576022 12.9202885 5.86576022 12.1873125 5.61200022 11.5773124 5.1435202L8.94796834 2.80112011C8.74593634 2.6254401 8.72739233 2.31312009 8.90697634 2.11792008 9.08753635 1.91296007 9.39595236 1.89344007 9.59603237 2.07888008L12.2009765 4.39200017C12.9017445 4.93856019 13.8718885 5.04592019 14.7063686 4.65552018L19.7825448 2.01056008C20.0226408 1.88368007 20.3164168 1.97152008 20.4403688 2.21552008 20.5652968 2.44976009 20.4735528 2.75232011 20.2334568 2.86944011L20.2334568 2.86944011zM17.4704007 8.58880033C17.3747527 8.71568033 17.2273767 8.78400034 17.0800007 8.78400034 16.9784967 8.78400034 16.8750406 8.75472034 16.7872006 8.68640033L14.8352006 7.22240028C14.6195046 7.05648027 14.5765606 6.75392026 14.7376006 6.53920025 14.9005926 6.32448024 15.2060806 6.28544024 15.4208006 6.44160025L17.3728007 7.9056003C17.5884967 8.07152031 17.6314407 8.37408032 17.4704007 8.58880033L17.4704007 8.58880033zM11.4055364 6.79296026L6.52553625 8.74496034C6.46600025 8.77424034 6.40451225 8.78400034 6.34400024 8.78400034 6.15075224 8.78400034 5.96726423 8.66688033 5.89113623 8.48144033 5.79158422 8.22768032 5.91260823 7.9446403 6.16246424 7.8470403L11.0424644 5.89504023C11.2913444 5.78768022 11.5763364 5.91456023 11.6768644 6.15856024 11.7764165 6.41232025 11.6553924 6.69536026 11.4055364 6.79296026L11.4055364 6.79296026zM23.2034249.692960027C22.9350249.26352001 22.4694729 0 21.9590248 0L9.12852835 0C8.19742431 0 7.36196828.51728002 6.94521627 1.34688005L3.31254413 8.61808033C3.08318412 9.07680035 3.10758412 9.60384037 3.37598413 10.0430404 3.64340814 10.4724804 4.10993616 10.7360004 4.62038418 10.7360004L17.4518567 10.7360004C18.3819847 10.7360004 19.2174407 10.2187204 19.6341928 9.38912036L23.2688169 2.11792008C23.4972009 1.65920006 23.4728009 1.13216004 23.2034249.692960027L23.2034249.692960027zM4.39200017 1.95200007L.488000019 1.95200007C.218624008 1.95200007 0 1.73728007 0 1.46400006 0 1.19072005.218624008.976000037.488000019.976000037L4.39200017.976000037C4.66137618.976000037 4.88000019 1.19072005 4.88000019 1.46400006 4.88000019 1.73728007 4.66137618 1.95200007 4.39200017 1.95200007M.488000019 9.76000037C.361120014 9.76000037.234240009 9.71120037.145424006 9.61360037.0488000019 9.52576037 0 9.39888036 0 9.27200036 0 9.14512035.0488000019 9.02800035.136640005 8.93040034.341600013 8.73520034.653920025 8.74496034.829600032 8.92064034.927200036 9.01824035.976000037 9.14512035.976000037 9.27200036.976000037 9.40864036.916464035 9.53552037.829600032 9.62336037.741760028 9.71120037.614880024 9.76000037.488000019 9.76000037M2.44000009 5.85600022L.488000019 5.85600022C.218624008 5.85600022 0 5.64128022 0 5.36800021 0 5.0947202.218624008 4.88000019.488000019 4.88000019L2.44000009 4.88000019C2.7093761 4.88000019 2.92800011 5.0947202 2.92800011 5.36800021 2.92800011 5.64128022 2.7093761 5.85600022 2.44000009 5.85600022"
        />
      </svg>
    </>
  ),
};
